module.exports = __webpack_public_path__ + "img/AC_S3_Final.c9bc501f.jpg";